import { Route } from "vue-router";
import { RouteConfig } from "vue-router";
import config from "@/config";
import { enrichRouteMeta } from "@/router/helpers";

const commonProfileRouteFields = (name: string): Partial<RouteConfig> => ({
  props: {
    default: (route: Route) => ({ userId: route.params.userId, feedId: route.query.feedId, tab: route.query.tab }),
    createPost: true,
  },
  components: {
    default: () => import(/* webpackChunkName: "profile" */ "@/views/PageProfile"),
    unlockFeed: () => import(/* webpackChunkName: "profile" */ "@/views/UnlockFeed"),
  },
  children: [
    {
      name: `${name}/live`,
      path: "live",
      props: route => ({ userId: route.params.userId }),
      component: () => import(/* webpackChunkName: "profile" */ "@/views/PageProfile/components/StreamController"),
    },
  ],
});

const routes: RouteConfig[] = [
  ...(config.soloCreatorId !== null
    ? [
        {
          path: "/",
          name: "profileBySoloCreatorId",
          ...commonProfileRouteFields("profileBySoloCreatorId"),
          meta: {
            toBottom: true,
          },
        },
      ]
    : []),
  {
    path: "/profile/:userId",
    name: "profileById",
    ...commonProfileRouteFields("profileById"),
  },
  {
    path: "/login/token/:token",
    name: "loginToken",
    component: () => import("@/views/PageLoginToken"),
    props: true,
  },
  {
    path: "/logout",
    name: "logout",
  },
  {
    path: "/:username",
    name: "profile",
    ...commonProfileRouteFields("profile"),
    meta: {
      toBottom: true,
    },
  },
  {
    path: "/discover",
    name: "discover",
    props: {
      default: () => ({ onFeed: false }),
    },
    components: {
      default: () => import("@/views/PageDiscover"),
      unlockFeed: () => import(/* webpackChunkName: "profile" */ "@/views/UnlockFeed"),
    },
    beforeEnter(to, from, next) {
      if (config.soloCreatorId === null) {
        next();
        return;
      }
      next("/");
    },
  },
  {
    path: "/discover/feed",
    name: "discoverFeed",
    props: {
      default: () => ({ onFeed: true }),
    },
    components: {
      default: () => import("@/views/PageDiscover"),
      unlockFeed: () => import(/* webpackChunkName: "profile" */ "@/views/UnlockFeed"),
    },
    beforeEnter(to, from, next) {
      if (config.soloCreatorId === null) {
        next();
        return;
      }
      next("/");
    },
  },
  {
    path: "/complaints",
    name: "complaints",
    components: {
      default: () => import("@/views/PageComplaints"),
    },
  },
];

export default routes.map(route => enrichRouteMeta(route, {}));
